import { Injectable } from '@angular/core';
import { StartResponsePayload } from '@cpak/adp-cpak-bff-service-models';

import { Observable } from 'rxjs';
import { FetcherService } from '../fetcher/fetcher.service';

@Injectable({
  providedIn: 'root',
})
export class StartRepositoryService {
  constructor(private fetcher: FetcherService) {}

  public getStart(): Observable<StartResponsePayload | null> {
    return this.fetcher.get<StartResponsePayload | null>('/api/start');
  }
}
